<!-- List of available products belonging to the selected category-->
<template>
  <v-row class="ma-0">
    <v-col id="productList" cols="12">
      <v-btn
        v-if="propsData.productsWithoutCategory.length === 0"
        depressed
        color="secondary"
        @click="backToCategories"
      >
        <v-icon class="secondary-font-color" left>keyboard_arrow_left</v-icon>
        <div class="secondary-font-color">{{ $translate('BACK') }}</div>
      </v-btn>
    </v-col>
    <template>
      <v-card
        v-if="subCategories.length"
        width="100%"
        id="allCategories"
        flat
        color="transparent"
      >
        <v-card-title>
          <h2 class="black--text homepageTitle">{{ $translate('CATEGORIES') }}</h2>
        </v-card-title>

        <v-card-text>
          <ItemGroup
            :items="subCategories"
            itemImgSrc="PictureUrl"
            itemText="Name"
            :wrap="true"
            @select="onCategoryClick"
          />
        </v-card-text>
      </v-card>
    </template>

    <v-col cols="12" v-if="productList.length > 0">
      <h2>{{ $translate('PRODUCTS') }}</h2>
    </v-col>

    <template v-for="(product, index) in productList">
      <v-col :key="index" cols="12" sm="6" md="4" lg="3">
        <ProductCard :product="product" @view="goToProduct(product, index)" />
      </v-col>
    </template>


<!--    <template v-for="(category, index) in subCategories">-->
<!--      <v-col :key="`subCategory-${index}`" cols="12" sm="6" md="4" lg="3">-->
<!--        <section>-->
<!--          <v-hover v-slot="{ hover }">-->
<!--            <v-card height="100%" :elevation="hover ? 4 : 1" @click="onCategoryClick(category)">-->
<!--              <v-img-->
<!--                :src="category.PictureUrl != null ? category.PictureUrl : ''"-->
<!--                :aspect-ratio="1.618 / 1"-->
<!--              >-->
<!--              </v-img>-->

<!--              <v-card-text style="min-height: 106px">-->
<!--                <div class="text-subtitle-1 font-weight-bold mx-auto text-center">-->
<!--                  {{ category.Name }}-->
<!--                </div>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-hover>-->
<!--        </section>-->
<!--      </v-col>-->
<!--    </template>-->

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import uiHelpers from '@/shared/ui_helpers';
import doRequest, { addLog } from '@/api/dssRequest';
import ProductCard from '@/components/generalComponents/product/ProductCard';
import ItemGroup from "@/components/generalComponents/uiComponents/ItemGroup.vue";

export default {
  name: 'EventDetailsProducts_ProductList',
  mixins: [uiHelpers],
  components: {
    ProductCard,
    ItemGroup,
  },
  props: {
    propsData: {},
    scrollToSection: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      scrollToSectionRef: this.scrollToSection,
      productList: [],
      subCategories: [],
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },

  computed: {
    ...mapGetters({
      currentSelectedShoppingList: 'getCurrentSelectedShoppingList',
      isProfUser: 'isProfUser',
    }),
    partnerUserRelations() {
      return this.$store.getters['auth/partnerUserRelations'];
    },
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.$store.commit('setCurrentDetailsForEventPage', {
      Type: 'ProductCategory',
      Id:
        this.propsData.selectedCategory.CategoryId ||
        this.propsData.selectedCategory.Id,
      Description: this.propsData.selectedCategory.Description,
      Name: this.propsData.selectedCategory.Name,
      Picture: this.propsData.selectedCategory.PictureUrl,
      Video: '',
      PortraitVideo: '',
    });

    this.initProducts();
  },
  updated() {
    if (this.scrollToSectionRef) {
      this.scrollToSectionRef = false;
      window.EventBus.fire('scrollToRightPosition', '#eventDetailsProducts');
    }
  },
  metaInfo() {
    return {};
  },
  methods: {
    initProducts() {
      if (this.propsData.productsWithoutCategory.length === 0) {
        if (!_.isEmpty(this.$store.getters['category/categoryDetails'])) {
          // set the products in the product list
          if (
            this.$store.getters['category/categoryDetails'].Products != null
          ) {
            this.productList =
              this.$store.getters['category/categoryDetails'].Products;
          }
          // clear the store for categoryDetails
          this.$store.commit('category/setCategoryDetails', {});
        } else {
          // call getProductsByCategory only when there are no details yet
          this.getProductsByCategory();
        }
      } else {
        this.productList = this.propsData.productsWithoutCategory;
      }
    },
    truncateDescription(description) {
      if (this.$vuetify.breakpoint.name === 'xs') {
        // show full description on mobile format
        return description;
      }
      // return description with that is not to long
      return description.length > 70
        ? `${description.substr(0, 70)}... `
        : description;
    },
    backToCategories() {
      // Clearing current Details for event page
      // this.$store.commit('setCurrentDetailsForEventPage', {});
      // this.goToPage('EventDetails', {
      //   event_id: this.$route.params.event_id
      // });
      this.$router.back();
    },
    goToProduct(product, index) {
      console.log('goToProduct - id: ', product.Id)
      addLog(
        this.$store.getters['auth/userName'],
        product.Id,
        'Product',
        'ProductCategory',
        index
      );
    },
    getProductsByCategory() {
      const payload = {
        ProductCategoryId: this.propsData.selectedCategory.Id,
        UnrollSubCategories: false, // for subcategories
      };

      const object = this.$store.getters['auth/userName']
        ? this.$store.getters['auth/userName']
        : this.$store.getters['auth/tmpUserId'];

      doRequest(
        (response) => {
          if (response.data.ProductCategory.Products != null) {
            this.productList = response.data.ProductCategory.Products;
          }

          if(response.data.ProductCategory.SubCategories != null && response.data.ProductCategory.SubCategories.length > 0) {
            this.subCategories = response.data.ProductCategory.SubCategories;
          }

          if (
            response.data.ProductCategory != null &&
            response.data.ProductCategory.MetaData != null
          ) {
            window.EventBus.fire(
              'updateMetaData',
              response.data.ProductCategory.MetaData
            );
          }
        },
        () => {},
        'getProductsByCategory',
        object,
        payload,
        'GET'
      );
    },
    onCategoryClick(category) {
      this.$store.commit('setCurrentDetailsForEventPage', {});
      this.$store.commit('setCurrentDetailsForEventPage', {
        Type: 'ProductCategory',
        Id: category.Id,
        Description: category.Description,
        Name: category.Name,
        Picture: category.PictureUrl,
        Video: '',
        PortraitVideo: '',
      });

      addLog(
        this.$store.getters['auth/userName'],
        category.Id,
        'ProductCategory',
        'Home',
        -1
      );

      this.goToPage('ProductCategory', {
        event_id: category.EventId,
        category_id: category.Id,
      });
    },
  },
};
</script>
